const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";

import GameServer from "../../../hall/server/gameserver/game_server";
import ModuleManager from "../../../../framework/core/module_manager";
import PlayerListModule from "./../playerlist/playerlist_module"
import ModelData from "../../../public/model_data";
import EventManager from "../../../../manager/event_manager";
import RoadMapInfo from "../roadmapinfo/roadmapinfo_module";
import SceneManager from '../../../../manager/scene_manager';
import DialogTips from "../../../public/module/dialog_tips/dialog_tips"
import LanguageManager from "../../../../manager/language_manager";
import MorePanel from "../../../table/module/game_morepanel/game_morepanel"
import UserDataManager from "../../../../manager/user_manager";
import BankerListModule from "../../../table/module/bankerlist/bankerlist_module";
import BaseTableView from "./base_table_view";
import BaseTableModel from "./base_table_model";
import TableBaseModule from "../../../table/module/table_base/table_base_module";
import { joinUtil } from "../../../public/join_util";

@ccclass
export default class BaseTableModule <T extends BaseTableView, U extends BaseTableModel> extends TableBaseModule<T, U>  {

    currentGold = 0
    localBetIndex = 0 //本地下注的Index
    betIndex = 0 //服务器返回的
    currentBetType = null
    initBetData = null //押注数据
    currentResult = null //当前结果
    twentyTimesResult = null //最近20场记录
    isCanBet = false  //是否可下注
    roomStatus = null //房间状态
    m_lastRefreshTime = 0
    m_clockScheduleId = 0 //时钟ID
    superWinner = null //神算子
    myRoleData = null //自己的数据
    shangzhuang = false //上下庄标识
    bankers = [] //等待上庄玩家
    bankBtnType = 1//上庄状态
    isFristBetAim = false //是否播放开始下注动画
    myGold = 0
    retainCount = 0 //需要保留的筹码
    rule = null //房间规则
    currentRanker = null //当前庄家
    betNameList = null

    onShow(intentData) {
        this.model.init(GameServer.instance.netClient)
        this.model.clearMsgEvent()
        super.onShow(intentData);
        this.bindEvent()
        this.registNetMsg()
        this.view.initBetArea(this.betNameList)
        this.rule = ModelData.instance.roomInfo.PlayRuleData
        this.currentBetType = this.rule.game_BetArr[0]
        this.retainCount = this.rule.game_Retain || 0
        this.view.initBaseShow(this.rule)
    }

    protected onButtonClickName(name: string) {
        switch (name) {
            case "MoreBtn":
                ModuleManager.instance.showModule(MorePanel)
                break
            case "PlyerBtn":
                this.model.request_online_players()
                break;
            case "GoBankerBtn":
                this.openBankerList()
                break;
            case "CloseGoBankerBtn":
                if (this.currentRanker != null && (this.currentRanker.id == this.myRoleData.id)) {
                    //下庄提示 TODO
                    this.shangzhuang = true
                    this.model.request_hold_banker(2)
                }
                break 
            case "Head":
                //点击自己
                ModuleManager.instance.showEmojiModule(this.myRoleData.id,this.moduleName)
                break
            case "Player":
                //点击庄家
                ModuleManager.instance.showEmojiModule(Number(this.currentRanker.id), this.moduleName)
                break
            default:
                break;
        }
    }

    protected onButtonClick(obj: cc.Node) {
        if (obj.parent == this.view.betObj || obj.parent == this.view.betOther) {
            this.view.showChooseJetton(obj)
            this.currentBetType = this.view.jettonItemBtns[obj.name].Count
        }
        else if (obj.parent.name == "BetArea") {
            this.isBet(obj.name)
        }
        else if (obj.parent.name == "Players"){
            this.clickPlayIcon(obj)
        }
        else {

        }
    }

    clickPlayIcon(posNode)
    {
        for (const playerItem of this.view.playerItems) {
            if (playerItem.Obj == posNode && playerItem.Id != null){
                ModuleManager.instance.showEmojiModule(playerItem.Id,this.moduleName)
                return
            }
        }
        
    }

    getSeatNodeById(id){
        if (id == this.myRoleData.id){
            return this.view.playerItems[6].Icon.node
        }

        if (this.currentRanker != null &&  id == this.currentRanker.id){
            return this.view.bankerHead.node
        }
        for (const playerItem of this.view.playerItems) {
            if ( playerItem.Id == id){
                return playerItem.Icon.node
            }
        }
        return null
    }



    registNetMsg() {
        
    }

    //#region 注册消息方法

    //收到压住消息
    betRspEvent(protoData){
        this.currentGold = this.currentGold + this.currentBetType
        this.scheduleOnce(() => {
            this.betIndex += 1
            //押注失败
            if (protoData.errorCode != 0) {
                //押注失败 返回一个筹码
                ModuleManager.instance.toastKey("server_error_"+ protoData.errorCode)
                if (this.view.betDataByIndex[this.betIndex] != null) {
                    this.myGold += this.view.betDataByIndex[this.betIndex].type == null ? 0 : this.view.betDataByIndex[this.betIndex].type
                    this.view.playBetDefeated(this.betIndex, this.myGold)
                    this.aotuChooseBetBtn()
                    this.view.updateJettonMask(this.myGold - this.retainCount, false)
                }
            }
        }, 0.2) //往后延迟一点点 让押筹码 和回来得流程完整
    }

    //收到更新压住
    betBroadCastEvent(protoData){
        if (this.initBetData == null) {
            if (this.roomStatus != 7){
                this.view.refreshBetArea(protoData.totalData, protoData.selfTotalBetData.data)
                this.view.playOtherBetAmin(protoData.totalData, false, false)
            }
        }
        else {
            this.view.refreshBetArea(protoData.totalData, protoData.selfTotalBetData.data, !this.isCanBet)
            this.disPoseNewBetData(protoData)
        }
        this.initBetData = protoData
    }

    //接受离开房间消息
    leaveRspEvent(protoData){
        if (protoData.errCode != -226) {
            this.leaveRoom()
            SceneManager.gotoHallOrClubHall("TabelExit")
            if (protoData.errNo != "0"){
                ModuleManager.instance.showModule(DialogTips, { Content: LanguageManager.t("server_error_" + protoData.errCode),titleError : true })
            }
        }
        else{
            ModuleManager.instance.toastKey("server_error_" + protoData.errCode)
        }
    }

    //收到错误的方法
    notifyMsgEvent(protoData){
        let str = ""
        if (protoData.code == 1) {
            str = LanguageManager.t("lhd_tipsBetExit")
        }
        ModuleManager.instance.showModule(DialogTips, { Content: str ,titleError: true  })
    }

    //收到更新上庄列表
    bankerListEvent(protoData){
        this.bankers = protoData.bankers
        this.bankBtnType = 1
        for (const value of this.bankers) {
            if (value.round == 0 && (value.id == this.myRoleData.id)) {
                this.bankBtnType = 2
                break
            }
        }
        if (this.currentRanker == null || this.currentRanker.id != this.myRoleData.id){
            this.view.updateBankerBtn(true, false)
        }
        EventManager.instance.dispatch("event_update_banker", { Data: this.bankers, BtnType: this.bankBtnType, Rule:this.rule})
    }

    //收到庄家更新
    bankerInfoEvent(protoData){
        this.currentRanker = protoData.banker
        if (protoData.isPlayer){
            this.view.updateBanker(protoData.banker.id, protoData)
            this.view.betObj.active = !(this.currentRanker.id == this.myRoleData.id)
            let isWaitBanker = true
            if (this.currentRanker.id == this.myRoleData.id && protoData.banker.round >= this.rule.pub_BeDealerMin){
                isWaitBanker = false
            }
            this.view.updateBankerBtn(!(this.currentRanker.id == this.myRoleData.id), !isWaitBanker)
        }
        else{
            this.view.banker.active = false
            this.view.sysBanker.active = true
            this.view.sysYizi.active = true
            this.view.lastBankerId = null
            this.view.betObj.active = true
            this.view.updateBankerBtn(true, false)
        }
    }

    //收到上下庄的消息
    bankerRspEvent(){
        if (this.shangzhuang) {
            this.shangzhuang = false
            ModuleManager.instance.toastKey("banker_close")
        }
    }

    //收到打开玩家列表
    openOnlinePlayerEvent(playerData){
        ModuleManager.instance.showModule(PlayerListModule, playerData.players)
    }
    //#endregion


    isBet(objName: string): boolean {
        if (this.currentRanker != null && this.currentRanker.id == this.myRoleData.id){
            return
        }
        if (this.roomStatus != 5 || !this.isCanBet) {
            ModuleManager.instance.toastKey("server_error_-205")
            return false
        }
        if (this.currentBetType == null) {
            ModuleManager.instance.toastKey("lhd_qxzyz");
            joinUtil.showRechargeInMultiple(this);
            return true
        }

        if (this.roomStatus == 7) {
            ModuleManager.instance.toastKey("lhd_zzkjshyz")
            return true
        }

        if ((this.myGold - this.currentBetType - this.retainCount) < 0) {
            ModuleManager.instance.toastKey("server_error_-41")
            return
        }

        let area = Number(objName)
        this.localBetIndex += 1
        this.myGold -= this.currentBetType
        this.view.playBetSelfAmin(this.currentBetType, area, this.localBetIndex, this.myGold)
        this.model.request_bet(area, this.currentBetType)
        this.aotuChooseBetBtn()
        this.view.updateJettonMask(this.myGold - this.retainCount, false)
        return true
    }

    //更新玩家信息 一般 结算的时候 或者刚进入
    updatePlayerInfo(roomInfo) {
        if (roomInfo.players == null) { return }
        let playerDatas = roomInfo.players
        this.view.isShowPlayerIndex = []
        for (const data of playerDatas) {
            let isUpdate = true //本次是否更新数据
            let isMySelf = ModelData.instance.roleData.id == Number(data.id)
            if (isMySelf) {
                this.myRoleData = data
                this.currentGold = 0
                isUpdate = false
                if (this.roomStatus == null || roomInfo.state == 7) {
                    this.myGold = Number(data.balance)
                    isUpdate = true
                    this.aotuChooseBetBtn()
                    UserDataManager.balanceChangeMessage(this.myGold)
                }
                if ((this.currentRanker != null) && (this.currentRanker.id == this.myRoleData.id)) {
                    this.view.updateJettonMask(this.myGold - this.retainCount, true) //当为庄家时  设置0 为全部置灰
                }
                else{
                    this.view.updateJettonMask(this.myGold - this.retainCount, roomInfo.state != 5)
                }

            }

            if (data.isSuperWinner) {
                this.superWinner = data //神算子
            }
            UserDataManager.setUserGameTableCurrency(Number(data.id), Number(data.balance))
            this.view.updatePlayerInfo(data, isUpdate, isMySelf)
        }

        if (playerDatas.length < 7) {
            this.view.hidePlayerItem()
        }

    }

    //自动选择下注按钮 遇到更新上一次选择的筹码本次不够时候 还要更新到可用的最大的
    aotuChooseBetBtn() {
        if (this.myRoleData == null) { return }
        let canBetCount = this.myGold -  this.retainCount
        if (this.currentBetType != null){
            if (this.currentBetType > canBetCount){
                
                let objItemData = null
                for (const key in this.view.jettonItemBtns) {
                    if (this.view.jettonItemBtns.hasOwnProperty(key)) {
                        const element = this.view.jettonItemBtns[key];
                        if (element.Count <= canBetCount){
                            objItemData = element
                        }
                    }
                }
                if (objItemData != null){ 
                    this.onButtonClick(objItemData.BtnObj.node)
                }
                else{
                    this.currentBetType = null
                    this.view.showChooseJetton(null)
                }
            }
        }
        else{
            const element = this.view.jettonItemBtns["1"];
            if (element.Count <= canBetCount){
                this.onButtonClick(element.BtnObj.node)
            }
        }
    }


    //显示剩余下注时间
    showBetTime(time: number, isBet: boolean = false) {
        // if (!isBet || time <= 2){
        //     this.view.clockNode.active = false
        //     return
        // }
        // this.view.clockNode.active = true
        if (this.m_clockScheduleId > 0) {
            this.cancelSchedule(this.m_clockScheduleId)
            this.m_clockScheduleId = 0
        }
        let self = this
        var refreshClockLable = function () {
            if (time < 0) { return }
            self.view.clockLab.string = time.toString()
            self.m_clockScheduleId = self.doScheduleOnce(function () {
                self.m_clockScheduleId = 0
                time--
                if (isBet) {
                    if (time == 5) {
                        self.view.playDaoJiShi()
                    }
                    if (time == 1) {
                        self.view.updateJettonMask(self.myGold - self.retainCount, true)
                        self.isCanBet = false //最后一秒同步下本地数据 停止下注
                        if (self.initBetData != null) {
                            self.view.refreshBetArea(self.initBetData.totalData, self.initBetData.selfTotalBetData.data, true)
                        }

                        self.view.showBetTips(false, null)
                    }
                }
                refreshClockLable()
            }, 1)
        }
        refreshClockLable()
    }

    //打开上庄列表
    openBankerList() {
        ModuleManager.instance.showModule(BankerListModule, { Data: this.bankers, BtnType: this.bankBtnType, Rule:this.rule})
    }

    //处理新的押注数据
    disPoseNewBetData(betData) {
        if (betData.newData == null || betData.newData.length <= 0) { return }
        if (betData.playersBetData == null) { return }
        let otherBetData = betData.newData
        let isPlaying = false
        for (const value of betData.playersBetData) {
            if (value.data != null) {
                isPlaying = value.id != this.myRoleData.id
                let isSuperWinner = (this.superWinner != null) ? (value.id == this.superWinner.id) : false
                this.view.playBetAmin(value, value.id == this.myRoleData.id, otherBetData, isSuperWinner)
            }
        }

        if (isPlaying) {
            this.view.tableSound.playBet(false)
        }

        this.view.playOtherBetAmin(otherBetData, true, isPlaying)
    }

    requestHoldBanker() {
        if (this.bankBtnType == 1 && this.myGold < this.rule.pub_BeDealerLimit){
            ModuleManager.instance.toast(LanguageManager.t("banker_tips").format(this.rule.pub_BeDealerLimit))
            return
        }
        this.model.request_hold_banker(this.bankBtnType)
    }

    private bindEvent() {
        let self = this
        this.eventBind("event_req_banker", this.requestHoldBanker);
        this.eventBind("event_exit_game", function () {
            self.model.request_leave_room()
        });
    }

    leaveRoom() {
        this.view.tableSound.stopBgm()
        ModuleManager.instance.destroyModule("RoadMapInfo")
    }

    protected onUserCoinBalanceNotify(data: {playerId: number, coinBalance: number}){
        super.onUserCoinBalanceNotify(data)
        this.view.refreshPlayerCoinBalance(data.playerId, data.coinBalance)
    }
}